import React from 'react';
import { Divider, IconButton, Typography } from '@mui/material';
import { GoogleCalendar, ICalendar } from 'datebook';

import googleCalebdarIcon from 'assets/images/google-calendar-icon.svg';
import outlookCalebdarIcon from 'assets/images/outlook-calendar-icon.svg';
import iphoneCalebdarIcon from 'assets/images/iphone-calendar-icon.svg';

import { ClosableModal } from 'components';

interface AddCalendarDialogProps {
  open: boolean;
  onClose: () => void;
  config: any;
}

const AddToCalendarModal = ({
  open,
  onClose,
  config,
}: AddCalendarDialogProps) => {
  const googleCalendarHandler = () => {
    const googleCalendar = new GoogleCalendar(config);
    const link = googleCalendar.render();
    window.open(link, '_blank');
    onClose();
  };

  const icsCalendarHandler = () => {
    const icalendar = new ICalendar(config);
    icalendar.download();
    onClose();
  };

  return (
    <ClosableModal
      open={open}
      onClose={onClose}
      title="Add to your calendar"
      subTitle=""
      modalClass=""
    >
      <div className="d-flex align-items-center">
        <IconButton disableRipple sx={{ p: 0 }} onClick={googleCalendarHandler}>
          <img src={googleCalebdarIcon} alt="Goolge Calendar" />
          <Typography variant="body2" sx={{ ml: 1 }}>
            Google Calendar
          </Typography>
        </IconButton>
        <Divider orientation="vertical" flexItem sx={{ ml: 3, mr: 3 }} />
        <IconButton disableRipple sx={{ p: 0 }} onClick={icsCalendarHandler}>
          <img
            src={iphoneCalebdarIcon}
            alt="iOS Calendar"
            width="31"
            height="31"
            style={{ border: '1px solid #ccc', borderRadius: '8px' }}
          />
          <Typography variant="body2" sx={{ ml: 2 }}>
            iCal
          </Typography>
        </IconButton>
        <Divider orientation="vertical" flexItem sx={{ ml: 3, mr: 3 }} />
        <IconButton disableRipple sx={{ p: 0 }} onClick={icsCalendarHandler}>
          <img src={outlookCalebdarIcon} alt="Outlook Calendar" />
          <Typography variant="body2" sx={{ ml: 1 }}>
            Outlook
          </Typography>
        </IconButton>
      </div>
    </ClosableModal>
  );
};

export default AddToCalendarModal;
